import { lastValueFrom } from 'rxjs';

import { sendMail } from '../slices/contact.slice';
import { showConfirmModal } from '../slices/gui.slice';

import ConfirmMessage from '@/components/search/ConfirmMessage';
import { AppDispatch, AppListenerEntry } from '@/redux';
import { NS } from '@/constants';
import { valueof } from '@/types';
import { STATUS } from '@/constants/contact';

const keyPrefix = 'noSearchResult.contactForm';

export const epicSendMail: AppListenerEntry = {
  actionCreator: sendMail,
  effect: async ({ payload }: ReturnType<typeof sendMail>, { dispatch, extra: { contactService } }) => {
    const { t, form, host, options } = payload;
    if (options?.onSubmit) {
      options.onSubmit();
    }
    try {
      await lastValueFrom(contactService.sendMail(form, host));
      dispatch(openConfirmModal(dispatch, t, STATUS.OK, options.onConfirm));
    } catch (erroro) {
      dispatch(openConfirmModal(dispatch, t, STATUS.ERR));
    }
  }
};

const openConfirmModal = (
  dispatch: AppDispatch,
  t: (_k: string, options?: any) => string,
  status: valueof<typeof STATUS>,
  cancelClick = undefined
) => {
  const key = `${keyPrefix}.modal.${status}`;
  const message = {
    info: t(`${key}.message.info`, { ns: NS.CATEG }),
    save: t(`${key}.message.save`, { ns: NS.CATEG })
  };

  return dispatch(showConfirmModal({
    content: {
      title: t(`${key}.title`, { ns: NS.CATEG }),
      content: <ConfirmMessage isError={status === STATUS.ERR} {...message} />,
      cancel: t('product.continueShopping'),
      cancelClick
    }
  }));
};
